import { useEffect, useState } from "react";
import "./CardProject.css"
import { load as loadProjectList } from '../../reducers/models/project/projectList'
import { useDispatch, useSelector } from "react-redux";
import Switch from "../ui/Switch";
import axios from "axios";


function CardProject({ selected, changeHandler, all, allHandler }) {

  const dispatch = useDispatch()

  const stateProjectList = useSelector((state) => state.projectList);

  const [loading, setLoading] = useState(false);
  const [log, setLog] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    if (stateProjectList.listLoaded.filter(a => a.id_status === 1).length === 0) {
      setLoading(false);

      axios.get('/api_tracker/project/list', { params: { ID_Status: 1 } })
        .then((res) => {
          if (res.data.Status === 1) {
            dispatch(loadProjectList({ list: res.data.Data, id_status: 1 }));
            setLoading(false);
          }
          else {
            setLog(res.data.Error);
            setLoading(false);
          }
        })
        .catch((err) => {
          setLog('Неизвестная ошибка!');
          setLoading(false);
        });
    }
    setSelectedItem(selected);
  }, []);

  useEffect(() => {
    setSelectedItem(selected);
  }, [selected]);

  function changeHandler_(id, val) {
    if (val === true) {
      const res = [...selectedItem.filter(a => a !== id), id];
      setSelectedItem(res);
      changeHandler(id, val);
    }
    else {
      const res = selectedItem.filter(a => a !== id);
      setSelectedItem(res);
      changeHandler(id, val);
    }
  }

  function List_Item({ items, id_parent }) {
    return (
      <ul className={id_parent === null ? ("project_checkbox") : ("project_checkbox_children")}>
        {items.map((res) => (
          <li key={res.ID}>
            <div>
              <input type="checkbox" id={res.ID} defaultChecked={selectedItem.filter(a => a === res.ID).length > 0 ? true : false} onChange={(e) => changeHandler_(res.ID, e.target.checked)} />
              <label htmlFor={res.ID}>{res.Name}</label>
            </div>
            {stateProjectList.list.filter(a => a.ID_Parent === res.ID).length > 0 && (
              <List_Item items={stateProjectList.list.filter(a => a.ID_Parent === res.ID)} id_parent={res.ID} />
            )}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <>
      <Switch name="Все проекты" description="" checked={all} handleChange={allHandler} />
      {all === false && (
        <div className="project_checkbox_block">
          {stateProjectList.listLoaded.filter(a => a.id_status === 1).length > 0 && (
            <List_Item items={stateProjectList.list.filter(a => a.ID_Parent === null)} id_parent={null} />
          )}
        </div>
      )}
    </>
  )
}

export default CardProject; 